import api from './api';

const pitchDeckService = {
  // Get pitch deck for a project
  async getPitchDeck(projectId) {
    try {
      const response = await api.get(`/pitch-decks/${projectId}`);
      return response.data.data.pitchDeck;
    } catch (error) {
      // 404 is expected when no pitch deck exists yet
      if (error.response?.status === 404) {
        return null;
      }
      if (error.response?.status !== 404) {
        console.error('Error fetching pitch deck:', error);
      }
      throw error;
    }
  },

  // Save (create or update) pitch deck
  async savePitchDeck(projectId, deckData) {
    try {
      const response = await api.post(`/pitch-decks/${projectId}`, deckData);
      return response.data.data.pitchDeck;
    } catch (error) {
      console.error('Error saving pitch deck:', error);
      throw error;
    }
  },

  // Delete pitch deck
  async deletePitchDeck(projectId) {
    try {
      const response = await api.delete(`/pitch-decks/${projectId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting pitch deck:', error);
      throw error;
    }
  },

  // Get pitch deck history
  async getPitchDeckHistory(projectId) {
    try {
      const response = await api.get(`/pitch-decks/${projectId}/history`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching pitch deck history:', error);
      throw error;
    }
  }
};

export default pitchDeckService;
